import { Component, OnInit, Optional, Injector } from '@angular/core';
import { PrizeForPrecisionService } from '../../services/prize-for-precision.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { mergeMap, tap, map, withLatestFrom, filter } from 'rxjs/operators';
import { PriceForPrecisionAthlete } from '../../classes/prize-for-precision';
import { forkJoin, Observable } from 'rxjs';
import { IFilterComboComponent } from 'world-archery-lib';
import { environment } from '@environments/environment';
import { LoadDrupalLangService } from '../../../../common-page-components/services/load-drupal-lang.service';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: 'app-price-for-precision-panel',
  templateUrl: './price-for-precision-panel.component.html',
  styleUrls: ['./price-for-precision-panel.component.scss']
})
export class PriceForPrecisionPanelComponent extends DrupalLangClass implements OnInit {
  athletes: Array<PriceForPrecisionAthlete> = [];
  constructor(
    public filter_service: PrizeForPrecisionService,
    private http: HttpClient,
    injector: Injector,
  ) {
    super(injector);

  }

  ngOnInit() {
    this.filter_service.generateDefaultValues().pipe(
      withLatestFrom((this.filter_service.categoriesSubject.asObservable().pipe(filter(a => a !== undefined), map(a => a.items)))),
      mergeMap(
        ([values, options]) => {
          const params = {
            Year: values.year,
            content: environment.priceForPrecision.apiContentData,
            v: 3,
            Detailed: 1,
            RBP: 1,
          };
          const requestTodo = options.map(option => {
            const paramsSpecific = { Stage: option.WCupStage, CatCode: option.Cat };
            return this.http.get<any>('https://api.worldarchery.sport', {
              params: new HttpParams({ fromObject: Object.assign(params, paramsSpecific) as any })
            }).pipe(map(a => a));
          });

          return forkJoin(requestTodo)
            .pipe(
              map(a => {
                const data = [];
                a.forEach(value => {
                  (value as any).items.forEach(item => data.push(item));
                });
                data.forEach(value => {
                  value.catName = options.find(option => option.Cat === value.Cat).CatName
                })
                return data;
              }),
              map(a => a.sort((f, s) => f.Points > s.Points ? -1 : 1)),

            );
        })
    ).subscribe(next => {
      this.athletes = next;
    });
  }

  /**
   *
   * A method to decide if a value of points is shown in percent or raw
   * @param {number} value Numeric value of data to shown
   * @param {string} category_archer Category of the archer
   * @returns {Observable<string>}
   * @memberof PriceForPrecisionPanelComponent
   */
  ruleShowPercent(value: number, category_archer: string): Observable<string> {
    return (this.filter_service.categoriesSubject.asObservable().pipe(filter(a => a !== undefined), map(a => a.items)))
      .pipe(map(a => {
        const findedCategory = a.find(value => value.Cat === category_archer);
        return findedCategory.stagePercentageRule === true ? Math.round(value).toString() + ' %' : value.toString()
      }))
  }

  getNameCountry(country: string) {

    return this.filter_service.country.find(value => value.NOC === country);
  }
}
